import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppWidget from '../components/WhatsAppWidget';

// replace with real client-provided data (see rollout
// tracker: business registration, team photos, placement counts).
const MILESTONES = [
  { year: '2020', label: 'Inception in Harare', icon: 'flag', reached: true },
  { year: '2023', label: '50+ University Partnerships', icon: 'public', reached: true },
  { year: '2025', label: 'Job Placement Wing Started', icon: 'business_center', reached: true },
  { year: 'Present', label: '400+ Success Stories', icon: 'stars', reached: false },
];

const WHY_CHOOSE_US = [
  { icon: 'speed', title: 'Clear Application Process', desc: 'A structured portal and practical guidance keep your study abroad application moving.' },
  { icon: 'payments', title: 'Transparent Costs', desc: 'Understand consultancy fees and external costs before you make decisions.' },
  { icon: 'verified', title: 'Scholarship and Admissions Guidance', desc: 'Get informed support with courses, scholarship requirements and university applications.' },
  { icon: 'hub', title: 'Global Study Network', desc: 'Explore pathways with universities and employers in popular international destinations.' },
];

// PLACEHOLDER TEAMS
const TEAM = [
  { name: 'Team Member Name', role: 'Chief Executive Officer', image: '/images/team/placeholder-1.jpg' },
  { name: 'Team Member Name', role: 'Head of Job Placement', image: '/images/team/placeholder-2.jpg' },
  { name: 'Team Member Name', role: 'Director of Admissions', image: '/images/team/placeholder-3.jpg' },
];

export default function AboutPage() {
  return (
    <div className="bg-[#f7f9fb] font-['Plus_Jakarta_Sans'] min-h-screen">
      <Navbar />
      <main className="pt-20">
        {/* Hero */}
        <section
          className="py-32 text-center"
          style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 60%, #ff7b7b 100%)' }}
        >
          <div className="max-w-[1280px] mx-auto px-6">
            <h1 className="text-5xl font-bold text-white mb-4">About IASC Study Abroad Consultancy</h1>
            <p className="text-lg text-white/90 max-w-2xl mx-auto">
              Helping students and professionals access scholarships, international education and global career opportunities.
            </p>
          </div>
        </section>

        {/* Our Story */}
        <section className="py-24 bg-white">
          <div className="max-w-[1280px] mx-auto px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-24">
              <div className="space-y-4">
                <span className="text-[#ff8483] text-sm uppercase tracking-widest font-semibold">Our Journey</span>
                <h2 className="text-3xl font-bold text-[#00255a]">Our Story</h2>
                <p className="text-[#64748b] leading-relaxed">
                  IASC Consultancy was created to help ambitious students and professionals find clearer pathways to
                  international education, scholarships and overseas careers. We began with a simple goal: make trusted global opportunities easier to access.
                </p>
                <p className="text-[#64748b] leading-relaxed">
                  Today, our growing network of advisors, recruitment partners and educators supports applicants through
                  university selection, scholarship research, application preparation and relocation planning.
                </p>
              </div>
              <div className="relative">
                <img
                  className="rounded-xl shadow-xl w-full h-[400px] object-cover"
                  alt="IASC Consultancy office"
                  src="/images/office-background.jpg"
                />
              </div>
            </div>

            {/* Timeline */}
            <div className="relative py-12 overflow-x-auto pb-12">
              <div className="absolute top-1/2 left-0 w-full h-1 bg-[#eceef0] -translate-y-1/2" />
              <div className="flex justify-between min-w-[800px] relative">
                {MILESTONES.map((m) => (
                  <div key={m.year} className="flex flex-col items-center gap-4 px-4 w-1/4">
                    <div
                      className={`w-12 h-12 rounded-full flex items-center justify-center z-10 shadow-lg ${
                        m.reached ? 'text-white' : 'bg-[#eceef0] text-[#747781]'
                      }`}
                      style={m.reached ? { background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 60%, #ff7b7b 100%)' } : {}}
                    >
                      <span className="material-symbols-outlined">{m.icon}</span>
                    </div>
                    <div className="text-center">
                      <h4 className={`font-bold text-lg ${m.reached ? 'text-[#00255a]' : 'text-[#747781]'}`}>{m.year}</h4>
                      <p className="text-sm text-[#64748b]">{m.label}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="py-24 bg-[#f2f4f6]">
          <div className="max-w-[1280px] mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold text-[#00255a] mb-4">Why Students Choose IASC</h2>
              <p className="text-[#64748b]">Practical guidance for finding courses, scholarships and international opportunities.</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {WHY_CHOOSE_US.map((item) => (
                <div key={item.title} className="bg-white p-6 rounded-xl border border-[#e2e8f0] shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all">
                  <div className="w-12 h-12 bg-[#d8e2ff] rounded-lg flex items-center justify-center text-[#00255a] mb-4">
                    <span className="material-symbols-outlined">{item.icon}</span>
                  </div>
                  <h3 className="text-lg font-bold text-[#00255a] mb-2">{item.title}</h3>
                  <p className="text-[#64748b] text-sm">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Meet the Team */}
        <section className="py-24 bg-white" hidden>
          <div className="max-w-[1280px] mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold text-[#00255a] mb-4">Meet the Team</h2>
              <p className="text-[#64748b]">Leadership committed to your global future.</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {TEAM.map((member) => (
                <div key={member.name} className="group">
                  <div className="relative overflow-hidden rounded-xl mb-4">
                    <img
                      className="w-full h-80 object-cover transform group-hover:scale-105 transition-transform duration-500"
                      alt={member.name}
                      src={'/images/person-placeholder.jpg' /*member.image || */}
                    />
                    <div className="absolute inset-0 bg-[#00255a]/20 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </div>
                  <h4 className="text-lg font-bold text-[#00255a]">{member.name}</h4>
                  <p className="text-sm text-[#365da3]">{member.role}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-24 max-w-[1280px] mx-auto px-6">
          <div
            className="rounded-3xl p-12 text-center text-white relative overflow-hidden shadow-2xl"
            style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 60%, #ff7b7b 100%)' }}
          >
            <div className="relative z-10 space-y-6">
              <h2 className="text-4xl font-bold">Ready to start your study abroad journey?</h2>
              <p className="text-white/80 max-w-xl mx-auto">
                Explore courses, scholarship options and international pathways with guidance tailored to your goals.
              </p>
              <Link
                to="/apply"
                className="inline-block bg-white text-[#00255a] px-8 py-4 rounded-xl font-bold hover:shadow-xl hover:scale-105 transition-all"
              >
                Start Your Application
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppWidget />
    </div>
  );
}
